// @codekit-append "../node_modules/foundation-sites/dist/js/foundation.min.js";
// @codekit-append "../bower_components/slick-carousel/slick/slick.js";
// @codekit-append "../js/jquery.nice-select.min.js";
// @codekit-append "../js/masonry.pkgd.min.js";

var possibleLang = {
    '162' : ["de", "en", "ps", "prs"],//Afghanistan
    '70'  : ["de", "en", "sq"],       //Albanien
    '72'  : ["de", "en", "ar", "fr"],   //Marokko
    '69'  : ["de", "en", "ar", "ku"],   //Irak
    '75'  : ["de", "en", "ar", "fr"],   //Tunesien
    '71'  : ["de", "en", "fr"],         //Senegal
    '161' : ["de", "en", "sq"],        //Kosovo
    '73'  : ["de", "en", "sr", "lat"],         //Serbien
    '163' : ["de", "en"],               //Ghana
    '164' : ["de", "en"],               //Gambia
    '74'  : ["de", "en"]                //Nigeria
};

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name+'=; Max-Age=-99999999;';
}

jQuery(document).ready(function() {

	jQuery("ul.language-switcher-language-url li.kos").remove();
  function cartesian() {
      var r = [], arg = arguments, max = arg.length-1;
      function helper(arr, i) {
          for (var j=0, l=arg[i].length; j<l; j++) {
              var a = arr.slice(0); // clone arr
              a.push(arg[i][j]);
              if (i==max)
                  r.push(a);
              else
                  helper(a, i+1);
          }
      }
      helper([], 0);
      return r;
  }

  if(jQuery("body").hasClass("page-node-17")) {
    history.pushState({ page: 1 }, "title 1", "#nbb");
    window.onhashchange = function (event) {
        window.location.hash = "nbb";
        jQuery("a.btn-beduerfnisfinder.left").trigger("click");
    };
  }

  if(jQuery("select[name='location_to']").length) {
    var options = $('select[name="location_to"] option');
    jQuery( options[ 1 ] ).insertAfter( jQuery( options[ 3 ] ) );
  }

  if(jQuery(".more-perspektiven").length) {
    var seen = {};
    jQuery(".more-perspektiven li").each(function() {
        var txt = jQuery(this).html();
        if (seen[txt])
            jQuery(this).remove();
        else
            seen[txt] = true;
    });


    if(jQuery("div.moeglichkeiten-auto").length) {
      var perspC = 1;
      jQuery("div.moeglichkeiten-auto div.view-perspektiven-bei-success-storys ul li").each(function() {
        if(perspC > 5) {
          jQuery(this).remove();
        }
        perspC++;
      });
    };

    if(jQuery("body").hasClass("page-language-prs") || jQuery("body").hasClass("page-language-ps") || jQuery("body").hasClass("page-language-ar") || jQuery("body").hasClass("page-language-ku")) {
      jQuery('.more-perspektiven').masonry({
        itemSelector: '.more-perspektiven > li',
        isRTL: true,
        originLeft: false
      });
    } else {
      jQuery('.more-perspektiven').masonry({
        itemSelector: '.more-perspektiven > li'
      });
    }
  }

  setTimeout(function() {
      jQuery(document).foundation();
  }, 500);



  jQuery(document).on("click", "main", function(e) {
    jQuery(".menu-locale .arrow").removeClass("open");
    jQuery(".language-selection-dropdown").slideUp("fast", function() {
        jQuery(".language-selection-dropdown").removeClass("open");
    });
  });

  jQuery(document).on("click", ".modul--reintegrationsvorb .dropdown .title", function(e) {
    jQuery(".modul--reintegrationsvorb .dropdown .content").css("z-index", "10");
    jQuery(this).parent().find(".content").css("z-index", "99");
    jQuery(this).parent().toggleClass("open");
    jQuery(this).parent().find(".content").slideToggle();
  });


  function hasClass(elements, classes) {
      return elements.filter(function(index, elem) {
          return classes.some(function(klass) {
              return elem.classList.contains(klass);
          });
      }).length > 0;
  }
  function calcResults(area = "") {
    jQuery('div.results--elem').hide();

    if(jQuery('div.dropdown--bland').find('input:checked').length == 0 && jQuery('div.dropdown--thema').find('input:checked').length == 0 && jQuery('div.dropdown--traeger').find('input:checked').length == 0) {
      jQuery('div.results--elem').show();
    }

    var selClassFilter = "";
    var arrSelectedClassesBland = [];
    var arrSelectedClassesThema = [];
    var arrSelectedClassesTraeger = [];
    var selectedClassess = "";

      jQuery('div.dropdown--bland').find('input:checked').each(function () {
        arrSelectedClassesBland.push(jQuery(this).val());
      });

      jQuery('div.dropdown--thema').find('input:checked').each(function () {
        arrSelectedClassesThema.push(jQuery(this).val());
      });

      jQuery('div.dropdown--traeger').find('input:checked').each(function () {
        arrSelectedClassesTraeger.push(jQuery(this).val());
      });

      if(arrSelectedClassesBland.length != 0 && arrSelectedClassesThema.length == 0 && arrSelectedClassesTraeger.length == 0) {
        var asdf = cartesian(arrSelectedClassesBland);
      }
      if(arrSelectedClassesBland.length == 0 && arrSelectedClassesThema.length != 0 && arrSelectedClassesTraeger.length == 0) {
        var asdf = cartesian(arrSelectedClassesThema);
        console.log("Calc Thema"+arrSelectedClassesThema);
      }
      if(arrSelectedClassesBland.length == 0 && arrSelectedClassesThema.length == 0 && arrSelectedClassesTraeger.length != 0) {
        var asdf = cartesian(arrSelectedClassesTraeger);
      }
      if(arrSelectedClassesBland.length != 0 && arrSelectedClassesThema.length != 0 && arrSelectedClassesTraeger.length == 0) {
        var asdf = cartesian(arrSelectedClassesBland, arrSelectedClassesThema);
      }
      if(arrSelectedClassesBland.length != 0 && arrSelectedClassesThema.length == 0 && arrSelectedClassesTraeger.length != 0) {
        var asdf = cartesian(arrSelectedClassesBland, arrSelectedClassesTraeger);
      }
      if(arrSelectedClassesBland.length == 0 && arrSelectedClassesThema.length != 0 && arrSelectedClassesTraeger.length != 0) {
        var asdf = cartesian(arrSelectedClassesThema, arrSelectedClassesTraeger);
      }
      if(arrSelectedClassesBland.length != 0 && arrSelectedClassesThema.length != 0 && arrSelectedClassesTraeger.length != 0) {
        var asdf = cartesian(arrSelectedClassesBland, arrSelectedClassesThema, arrSelectedClassesTraeger);
      }

      /* Hide all Proposals */

      if(arrSelectedClassesThema.length != 0) {
        jQuery("div.proposal-container").parent().parent().parent().hide();



        jQuery(arrSelectedClassesThema).each(function(key,val) {
          //console.log(val);
          /* Show Proposals with Class */
          jQuery("div.proposal-container."+val).parent().parent().parent().show();

          //jQuery("div.proposal-container."+val).parent().parent().parent().parent().find("li:first-child").show();
        });



      } else {
        jQuery("ul.more-perspektiven li").show();
        //console.log("Show all");
      }


      jQuery(asdf).each(function() {
          jQuery(this).each(function(k,v) {
              selectedClassess += "."+v;
          });


          jQuery('div.results--elem'+selectedClassess).show();


          console.log("Show"+selectedClassess);
          selectedClassess = "";
      });




        jQuery("div.dropdown div.content:not([data-filter-btn-val-dropdown='"+area+"']) span[data-filtcont]").addClass("deactivate");
      jQuery('div.results--elem:visible').each(function() {
        var arrClasses = jQuery(this).attr("class").split(' ');


        jQuery.each( arrClasses, function( index, value ){
            jQuery('div.dropdown div.content span[data-filtcont="'+value+'"]').removeClass("deactivate");
        });

      });
      jQuery(".filterelems span").remove();
      jQuery("input[data-name]:checked").each(function() {
        jQuery(".filterelems").append('<span data-tid="'+jQuery(this).val()+'">'+jQuery(this).attr("data-name")+'</span>');
      })

      jQuery("input[data-traeger-name]:checked").each(function() {
        jQuery(".filterelems").append('<span data-tid="'+jQuery(this).val()+'">'+jQuery(this).attr("data-traeger-name")+'</span>');
      });

      jQuery("input[data-thema-name]:checked").each(function() {
        jQuery(".filterelems").append('<span data-tid="'+jQuery(this).val()+'">'+jQuery(this).attr("data-thema-name")+'</span>');
      });

      if(jQuery("body").hasClass("page-language-prs") || jQuery("body").hasClass("page-language-ps") || jQuery("body").hasClass("page-language-ar") || jQuery("body").hasClass("page-language-ku")) {
        jQuery('.more-perspektiven').masonry({
          itemSelector: '.more-perspektiven > li',
          isRTL: true,
          originLeft: false
        });
      } else {
        jQuery('.more-perspektiven').masonry({
          itemSelector: '.more-perspektiven > li'
        });
      }

            jQuery('.more-perspektiven').masonry('layout');

    }

    jQuery(document).on("click", ".modul--reintegrationsvorb span.btn", function(e) {
      jQuery(this).parent().parent().find("div.dropdown").toggleClass("open");
      jQuery(this).parent().parent().find("div.dropdown").find("div.content").slideToggle();

      var btnArea = jQuery(this).attr("data-filter-btn-val");

      var selVals = "";
      jQuery(this).parent().parent().find("div.dropdown").find("input:checked").each(function() {
        if(jQuery(this).attr("data-name") != undefined) {
          selVals += jQuery(this).attr("data-name")+", ";

        } else if(jQuery(this).attr("data-thema-name") != undefined) {
            selVals += jQuery(this).attr("data-thema-name")+", ";

        } else {
          selVals += jQuery(this).attr("data-traeger-name")+", ";
        }
      });

      if(selVals.substr(0, selVals.length - 2) == "") {
        jQuery(this).parent().parent().find("div.dropdown").find("span.title").html(jQuery(this).parent().parent().find("div.dropdown").find("span.title").attr("data-question"));
      } else {
        jQuery(this).parent().parent().find("div.dropdown").find("span.title").html("Filtern nach "+selVals.substr(0, selVals.length - 2));
      }
      //jQuery(this).parent().slideToggle();

      calcResults(btnArea);
    });
    jQuery(".content_themen").each(function(){
        jQuery(this).html($(this).children('span').sort(function(a, b){
            return (jQuery(b).data('filtcont')) < (jQuery(a).data('filtcont')) ? 1 : -1;
        }));
    });



    var liText = '', liList = jQuery('.content_themen span'), listForRemove = [];

    jQuery(liList).each(function () {

      var text = jQuery(this).attr("data-thema");

      if (liText.indexOf('|'+ text + '|') == -1)
        liText += '|'+ text + '|';
      else
        listForRemove.push(jQuery(this));

    });

    jQuery(listForRemove).each(function () {
      jQuery(this).remove();
    });

    jQuery(document).on("click", "div.addfilterelems span", function(e) {
        jQuery(this).hide();

        var selectedFilter = jQuery(this).attr("data-addfilterelem");
        jQuery( ".grid-container-filters" ).append( jQuery('div[data-filter-wrapper="'+selectedFilter+'"]') );
        jQuery('div[data-filter-wrapper="'+selectedFilter+'"]').fadeIn();
    });



    jQuery(document).on("click", ".filter--btn-showfilter", function(e) {

      // Reset all
      jQuery(".dropdown-maintop").toggleClass("open");
      jQuery('div[data-filter-wrapper="bundesland"]').hide();
      jQuery('div[data-filter-wrapper="thema"]').hide();
      jQuery('div[data-filter-wrapper="traeger"]').hide();
      jQuery('div[data-filter-wrapper="bundesland"] input').prop( "checked", false );
      jQuery('div[data-filter-wrapper="thema"] input').prop( "checked", false );
      jQuery('div[data-filter-wrapper="traeger"] input').prop( "checked", false );
      jQuery("div.filterelems span").remove();
      jQuery("div.results--elem").show();
      jQuery('div.addfilterelems span').css("display", "none");
      jQuery("div.dropdown div.content span").css("display", "block");

      jQuery("div.dropdown span.title").each(function() {
        var thisQuest = jQuery(this).attr("data-question");
        jQuery(this).html(thisQuest);
      });

      var selectedFilter = jQuery("input[name='filter']:checked").val();

      jQuery('div[data-filter-wrapper="'+selectedFilter+'"]').fadeIn();
      jQuery(".title--filtermain").html("Filtern nach "+jQuery("input[name='filter']:checked").attr("data-filtername"));
      jQuery("div.content--showfilter").slideToggle();
      jQuery('div.addfilterelems span:not([data-addfilterelem="'+selectedFilter+'"])').css("display", "block");
    });

    jQuery(document).on("click", ".modul--reintegrationsvorb .results .results--elem h3", function(e) {
      jQuery(this).parent().parent().parent().find(".results--elem-cont").slideToggle();
      jQuery(this).parent().parent().parent().find("h3.tit").toggleClass("open");

      if(jQuery("body").hasClass("page-language-prs") || jQuery("body").hasClass("page-language-ps") || jQuery("body").hasClass("page-language-ar") || jQuery("body").hasClass("page-language-ku")) {
        jQuery('.more-perspektiven').masonry({
          itemSelector: '.more-perspektiven > li',
          isRTL: true,
          originLeft: false
        });
      } else {
        jQuery('.more-perspektiven').masonry({
          itemSelector: '.more-perspektiven > li'
        });
      }
    });

    jQuery(document).on("click", ".filterelems span", function(e) {

      var valdel = jQuery(this).attr("data-tid");
      jQuery('input[value="'+valdel+'"]').prop( "checked", false );

      if(jQuery('input[value="'+valdel+'"]').parent().parent().find("input:checked").length == 0) {
        jQuery('input[value="'+valdel+'"]').parent().parent().parent().find("span.title").html(jQuery('input[value="'+valdel+'"]').parent().parent().parent().find("span.title").attr("data-question"));
      } else {
        var fitlertext = jQuery('input[value="'+valdel+'"]').parent().parent().parent().find("span.title").html();
        var res = fitlertext.replace(", "+jQuery(this).html(), "");
        jQuery('input[value="'+valdel+'"]').parent().parent().parent().find("span.title").html(res);

        var fitlertext = jQuery('input[value="'+valdel+'"]').parent().parent().parent().find("span.title").html();
        var res2 = fitlertext.replace("nach "+jQuery(this).html(), "nach ");
        jQuery('input[value="'+valdel+'"]').parent().parent().parent().find("span.title").html(res2);
      }

      calcResults();
      jQuery(this).remove();
    });

    jQuery(document).on("click", ".btn-beduerfnisfinder-restart", function(e) {
        e.preventDefault();


        var tid = getCookie("Drupal.visitor.bf_ftid_initial");

        setCookie('Drupal_visitor_bf_ftid', tid, 7);
        setCookie('Drupal.visitor.bf_ftid', tid, 7);
        setCookie('bf_ftid', tid, 7);

        window.location.href = jQuery(this).attr("data-redirect");

    });

    jQuery('.styleselect').niceSelect();
    calculateSelectionWidth();
    jQuery(document).on("click", ".mobile-menu-open", function() {
        jQuery(".mobile-menu-container").addClass("open");
        jQuery(".menu-open-bg-layer").fadeIn("fast");
    });

    if(getCookie("cookieconsent") != 1) {
      jQuery("div.cookie").fadeIn();
    }

    jQuery(document).on("click", "div.cookie a", function(e) {
      e.preventDefault();
      jQuery("div.cookie").fadeOut();
      setCookie('cookieconsent', 1, 7);
    });



    jQuery(document).on("click", ".mobile-menu-close, .menu-open-bg-layer", function() {
        jQuery(".mobile-menu-container").removeClass("open");
        jQuery(".menu-open-bg-layer").fadeOut("fast");
    });
    jQuery(document).on("click", ".top-menu .expanded", function() {
        var $childMenu = jQuery(this).find("ul.menu");
        if(!$childMenu.is(":visible")) {
            jQuery(this).addClass("open");
            $childMenu.slideDown("fast");
        } else {
            jQuery(this).removeClass("open");
            $childMenu.slideUp("fast");
        }
    });

    jQuery.each(jQuery(".success-story-teaser-large"), function() {
      if(jQuery(this).attr("data-background")) {
        jQuery(this).css("background-image", 'url('+jQuery(this).attr("data-background")+')');
      }
    });

    jQuery(document).on("click", ".menu-locale", function() {
        if(!jQuery("body").hasClass("page-node-17") && !jQuery("body").hasClass("page-node-22")) {
          if(jQuery(".language-selection-dropdown").hasClass("open")) { // Sprachauswahl schließen
              jQuery(".menu-locale .arrow").removeClass("open");
              jQuery(".language-selection-dropdown").slideUp("fast", function() {
                  jQuery(".language-selection-dropdown").removeClass("open");
              });
          } else { // Sprachauswahl öffnen
              jQuery(".menu-locale .arrow").addClass("open");
              jQuery(".language-selection-dropdown").slideDown("fast", function() {
                  jQuery(".language-selection-dropdown").addClass("open");
              });
          }
        }
    });

    if(jQuery(".slider-favorite-prospects").length) {

        if(jQuery("body").hasClass("page-language-prs") || jQuery("body").hasClass("page-language-ps") || jQuery("body").hasClass("page-language-ar") || jQuery("body").hasClass("page-language-ku")) {
          jQuery('.slider-favorite-prospects').slick({
              arrows: false,
              dots: true,
              autoplay: false,
              infinite: false,
              speed: 500,
              fade: false,
              cssEase: 'linear',
              slidesToShow: 4,
              responsive: [
                  {
                      breakpoint: 1024,
                          settings: {
                              slidesToShow: 3,
                          }

                  },
                  {
                      breakpoint: 768,
                          settings: {
                              slidesToShow: 2,
                          }

                  },
                  {
                      breakpoint: 667,
                          settings: {
                              slidesToShow: 1,
                          }

                  },
              ],
          });
        } else {
          jQuery('.slider-favorite-prospects').slick({
              arrows: false,
              dots: true,
              rtl: true,
              autoplay: false,
              infinite: false,
              speed: 500,
              fade: false,
              cssEase: 'linear',
              slidesToShow: 4,
              responsive: [
                  {
                      breakpoint: 1024,
                          settings: {
                              slidesToShow: 3,
                          }
                  },
                  {
                      breakpoint: 768,
                          settings: {
                              slidesToShow: 2,
                          }
                  },
                  {
                      breakpoint: 667,
                          settings: {
                              slidesToShow: 1,
                          }
                  },
              ],
          });
        }
    }

    if(jQuery(".view-perspektiven").length) {

        if(jQuery("body").hasClass("page-language-prs") || jQuery("body").hasClass("page-language-ps") || jQuery("body").hasClass("page-language-ar") || jQuery("body").hasClass("page-language-ku")) {
          jQuery('.view-perspektiven .view-content').slick( {
              arrows: true,
              dots: true,
              rtl: true,
              autoplay: false,
              infinite: false,
              speed: 500,
              fade: false,
              cssEase: 'linear',
              slidesToShow: 4,
              slidesToScroll: 1,
              responsive: [
                  {
                      breakpoint: 1024,
                          settings: {
                              slidesToShow: 3,
                          }
                  },
                  {
                      breakpoint: 768,
                          settings: {
                              slidesToShow: 2,
                          }
                  },
                  {
                      breakpoint: 667,
                          settings: {
                              slidesToShow: 1,
                          }
                  },
              ],
          });
        } else {
          jQuery('.view-perspektiven .view-content').slick( {
              arrows: true,
              dots: true,
              autoplay: false,
              infinite: false,
              speed: 500,
              fade: false,
              cssEase: 'linear',
              slidesToShow: 4,
              slidesToScroll: 1,
              responsive: [
                  {
                      breakpoint: 1024,
                          settings: {
                              slidesToShow: 3,
                          }
                  },
                  {
                      breakpoint: 768,
                          settings: {
                              slidesToShow: 2,
                          }
                  },
                  {
                      breakpoint: 667,
                          settings: {
                              slidesToShow: 1,
                          }
                  },
              ],
          });
        }
    }

    if(jQuery(".slider-more-success-stories").length) {

        if(jQuery("body").hasClass("page-language-prs") || jQuery("body").hasClass("page-language-ps") || jQuery("body").hasClass("page-language-ar") || jQuery("body").hasClass("page-language-ku")) {
          jQuery('.slider-more-success-stories').slick( {
              arrows: false,
              dots: false,
              autoplay: false,
              infinite: false,
              speed: 500,
              fade: false,
              cssEase: 'linear',
              slidesToShow: 4,
              responsive: [
                  {
                      breakpoint: 1024,
                          settings: {
                              slidesToShow: 3,
                          }
                  },
                  {
                      breakpoint: 768,
                          settings: {
                              slidesToShow: 2,
                          }
                  },
              ]
          });
        } else {
          jQuery('.slider-more-success-stories').slick( {
              arrows: false,
              dots: false,
              autoplay: false,
              infinite: false,
              rtl: true,
              speed: 500,
              fade: false,
              cssEase: 'linear',
              slidesToShow: 4,
              responsive: [
                  {
                      breakpoint: 1024,
                          settings: {
                              slidesToShow: 3,
                          }
                  },
                  {
                      breakpoint: 768,
                          settings: {
                              slidesToShow: 2,
                          }
                  },
              ]
          });
        }
    }

    jQuery(document).on("click", ".btn-beduerfnisfinder-inactive", function(e) {
      e.preventDefault();
    });

    var getCleanUrl = function(url) {
      return url.replace(/#.*$/, '').replace(/\?.*$/, '');
    };

    $("select[name='location_lang']").on('change', function() {
      var original_url = getCleanUrl($("a.btn-beduerfnisfinder-next").attr("href"));
      var url = original_url+"?lang="+$("select[name='location_lang'] option:selected").val();
      $("a.btn-beduerfnisfinder-next").attr("href", url);
    });

    $("select[name='rint']").on('change', function() {
      var thisTid = $(this).val();
      $('div.modul--reintegrationsscouts-result:not([data-bl-tid="'+thisTid+'"])').fadeOut( 500, function() {
        $('div.modul--reintegrationsscouts-result[data-bl-tid="'+thisTid+'"]').fadeIn();
      });
    });

    $("select[name='bz_loc']").on('change', function() {

      jQuery('div.nice-select.langselector ul li').hide();

      var choosenCountryBz = $("select[name='bz_loc'] option:selected").attr("data-bz-tid");
      jQuery.each(possibleLang[choosenCountryBz], function(key, value) {

        jQuery('div.nice-select.langselector ul li[data-value="'+value+'"]').show();
      });


      $("a.btn-beratungszentrum").attr("href", $( "select[name='bz_loc'] option:selected" ).attr("data-bz-"+$("select[name='location_lang_bz'] option:selected").val()));
      //$("a.btn-beratungszentrum").removeClass("btn-beduerfnisfinder-inactive");
      setCookie('bf_locto', $( "select[name='bz_loc'] option:selected").attr("data-bz-tid"));

      if($("select[name='bz_loc'] option:selected").val() != "0") {
        $(".question-container-lang").removeClass("question-container-deactivated");
      } else {
        $(".question-container-lang").addClass("question-container-deactivated");
      }
    });

    $("select[name='location_lang_bz']").on('change', function() {
      $("a.btn-beratungszentrum").attr("href", $( "select[name='bz_loc'] option:selected" ).attr("data-bz-"+$("select[name='location_lang_bz'] option:selected").val()));



    });


    $("select[name='location_in']").on('change', function() {


      jQuery("select[name='location_to']").niceSelect('destroy');

      $("select[name='location_to'] option").remove();
      var $options = $("select[name='location_in'] > option").clone();
      $options.prop("selected", false);
      $("select[name='location_to']").append($options);

      if($("select[name='location_in'] option:selected").val() != "0") {
        $(".question-container-locto").removeClass("question-container-deactivated");
      } else {
        $(".question-container-locto").addClass("question-container-deactivated");
      }

      if($(this).val() != "0") {
        setCookie('bf_locin', $(this).find(":selected").val(), 7);
      }
      /*
      if($("select[name='location_in'] option:selected").val() != "0" && $("select[name='location_to'] option:selected").val() != "0"){
        $("a.btn-beduerfnisfinder-next").removeClass("btn-beduerfnisfinder-inactive");
      } else {
        $("a.btn-beduerfnisfinder-next").addClass("btn-beduerfnisfinder-inactive");
      }
      */

      if($("select[name='location_in'] option:selected").val() != "0" && $("select[name='location_in'] option:selected").val() != "18") {
        var selectedOption = $("select[name='location_in'] option:selected").val();


        $("select[name='location_to'] option").each(function() {

          if($(this).val() != selectedOption && $(this).val() != 18 && $(this).val() != 0) {
            $(this).remove();
          } else {
            $(this).addClass("data-show-1");
          }
        });

        jQuery("select[name='location_to']").niceSelect();
        calculateSelectionWidth();
      } else if($("select[name='location_in'] option:selected").val() != "0" && $("select[name='location_in'] option:selected").val() == "18") {
        jQuery("select[name='location_to'] option").remove();
        var $options = jQuery("select[name='location_in'] > option[value!='18']").clone();
        jQuery("select[name='location_to']").append($options);
        jQuery("select[name='location_to']").niceSelect();
        calculateSelectionWidth();
      } else {

        jQuery("select[name='location_to'] option").remove();
        var $options = jQuery("select[name='location_in'] > option").clone();
        jQuery("select[name='location_to']").append($options);
        jQuery("select[name='location_to']").niceSelect();
        calculateSelectionWidth();
      }
    });


    $("select[name='location_lang']").on('change', function() {
      if($("select[name='location_in'] option:selected").val() != "0" && $("select[name='location_to'] option:selected").val() != "0" && $("select[name='location_lang'] option:selected").val() != "0"){
        $("a.btn-beduerfnisfinder-next").removeClass("btn-beduerfnisfinder-inactive");
      } else {
        $("a.btn-beduerfnisfinder-next").addClass("btn-beduerfnisfinder-inactive");
      }
    });

    $("select[name='location_lang_bz']").on('change', function() {
      if($("select[name='bz_loc'] option:selected").val() != "0" && $("select[name='location_lang_bz'] option:selected").val() != "0"){
        $("a.btn-beduerfnisfinder-next").removeClass("btn-beduerfnisfinder-inactive");
      } else {
        $("a.btn-beduerfnisfinder-next").addClass("btn-beduerfnisfinder-inactive");
      }
    });

    $("select[name='bz_loc']").on('change', function() {
      if($("select[name='bz_loc'] option:selected").val() != "0" && $("select[name='location_lang_bz'] option:selected").val() != "0"){
        $("a.btn-beduerfnisfinder-next").removeClass("btn-beduerfnisfinder-inactive");
      } else {
        $("a.btn-beduerfnisfinder-next").addClass("btn-beduerfnisfinder-inactive");
      }
    });

    $("select[name='location_to']").on('change', function() {
      if($("select[name='location_to'] option:selected").val() != "0") {
        $(".question-container-locin").removeClass("question-container-deactivated");
      } else {
        $(".question-container-locin").addClass("question-container-deactivated");
      }

      if($(this).val() != "0") {
        setCookie('bf_locto', $(this).find(":selected").val(), 7);
      }


      jQuery('div.nice-select.langselector ul li').hide();

      if($("select[name='location_to'] option:selected").val() == 18) {
        var choosenCountry = $("select[name='location_in'] option:selected").val();
      } else {
        var choosenCountry = $("select[name='location_to'] option:selected").val();
      }

      jQuery.each(possibleLang[choosenCountry], function(key, value) {

        jQuery('div.nice-select.langselector ul li[data-value="'+value+'"]').show();
      });
    });

    jQuery(document).on("click", ".answer", function() {
        jQuery(".answer").not(this).removeClass("active");

        var tid = $(this).attr("data-id");
        if(jQuery(this).hasClass("active")) { /* deaktivieren */
            jQuery(this).removeClass("active");
            jQuery(".with-input").removeClass("active");
            jQuery(".no-input").removeClass("inactive");
        } else {
            jQuery(this).addClass("active");
            jQuery(".no-input").addClass("inactive");
            jQuery(".with-input").addClass("active");
            setCookie('Drupal_visitor_bf_ftid', tid, 7);
            setCookie('Drupal.visitor.bf_ftid', tid, 7);
            setCookie('bf_ftid', tid, 7);
        }
    });

    jQuery(document).on("click", "a.prev", function(e) {
      e.preventDefault();

      var tid = $(this).attr("data-prev-tid");

      setCookie('Drupal_visitor_bf_ftid', tid, 7);
      setCookie('Drupal.visitor.bf_ftid', tid, 7);
      setCookie('bf_ftid', tid, 7);

      window.location.href = jQuery(this).attr("href");


    });




});

var lastScrollTop = 0;
var scrollDirection = "down";
var headerHeight = jQuery("header").outerHeight();
jQuery(window).scroll(function(event){
  if(jQuery(window).width() <= 1299) {
    var st = jQuery(this).scrollTop();

    if(st >= headerHeight) {
        jQuery(".desktop-toolbox").addClass("show");
    } else {
        jQuery(".desktop-toolbox").removeClass("show");
    }

    if (st > lastScrollTop){
        scrollDirection = "down";
    } else {
        scrollDirection = "up";
    }
    lastScrollTop = st;
  }
});

function calculateSelectionWidth() {
    if(jQuery(".dynamic-width").length) {
        jQuery.each(jQuery(".dynamic-width"), function() {
            var textWidth = jQuery(this).parent().find(".question-text").outerWidth();
            var parentContainerWidth = jQuery(this).parent(".question-container").innerWidth();
            var parentContainerMargin = parseInt(jQuery(this).parent(".question-container").css("margin-left"));
            var parentContainerPadding = parseInt(jQuery(this).parent(".question-container").css("padding-left"));
            var elementWidth = parentContainerWidth - textWidth - 2*parentContainerMargin - 2*parentContainerPadding - 10;
            jQuery(this).css({"width": elementWidth+"px"});
        });
    }
}

window.onresize = function(event) {
    calculateSelectionWidth();
};
